/**
 * @generated SignedSource<<767c2dff27e675e958d406e9d22c151d>>
 * @relayHash 0791d38d428cd9f7542404ac8983f065
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0791d38d428cd9f7542404ac8983f065

import { ConcreteRequest } from 'relay-runtime';
export type ContactRateInterval = "DAY" | "HOUR" | "MONTH" | "TWO_WEEK" | "WEEK" | "YEAR" | "%future added value";
export type UpdateContactInput = {
  avatarImage?: UploadedImageInput | null;
  companyName?: string | null;
  contactId: string;
  emailAddress?: string | null;
  feeInterval?: ContactRateInterval | null;
  feeMin?: any | null;
  firstName?: string | null;
  hasWorkedWithBefore?: boolean | null;
  lastName?: string | null;
  locationGooglePlaceId?: string | null;
  notes?: string | null;
  phoneNumber?: string | null;
  professionalTitle?: string | null;
  socialLinks?: ReadonlyArray<ExternalLinkInput> | null;
  sourceId?: string | null;
  tagIds?: ReadonlyArray<string> | null;
};
export type UploadedImageInput = {
  animated: boolean;
  checksum?: string | null;
  height: number;
  originalFormat: string;
  resourceType?: string | null;
  sizeBytes: number;
  uid: string;
  width: number;
};
export type ExternalLinkInput = {
  label?: string | null;
  url: any;
};
export type useCroppingContactMutation$variables = {
  input: UpdateContactInput;
};
export type useCroppingContactMutation$data = {
  readonly updateProfile: {
    readonly contact: {
      readonly privateContactMetadata: {
        readonly avatarImage: {
          readonly id: string;
          readonly uid: string;
          readonly url: string;
        } | null;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }> | null;
  };
};
export type useCroppingContactMutation = {
  response: useCroppingContactMutation$data;
  variables: useCroppingContactMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivateContactMetadata",
  "kind": "LinkedField",
  "name": "privateContactMetadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCroppingContactMutation",
    "selections": [
      {
        "alias": "updateProfile",
        "args": (v1/*: any*/),
        "concreteType": "UpdateContactPayload",
        "kind": "LinkedField",
        "name": "updateContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCroppingContactMutation",
    "selections": [
      {
        "alias": "updateProfile",
        "args": (v1/*: any*/),
        "concreteType": "UpdateContactPayload",
        "kind": "LinkedField",
        "name": "updateContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0791d38d428cd9f7542404ac8983f065",
    "metadata": {},
    "name": "useCroppingContactMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "80c2b728697a9650c2ca4c753b525a70";

export default node;
